module.exports = __webpack_public_path__ + "static/img/er-ci-kai-fa.246ca4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/er-ci-kai-fa.png
// module id = K0cZ
// module chunks = 3